<template>
    <div class="flex min-h-screen flex-col bg-muted">
        <Topbar />

        <!--
            One column, capped, mobile first. A booking is made on a telephone far more
            often than on a desk, so the phone is the design and the desktop is the
            phone with air around it — not the other way round.
        -->
        <main class="mx-auto w-full max-w-4xl flex-1 px-4 pb-16 pt-5">
            <router-view />
        </main>

        <!-- The house's address, and under it what is running. The version is
             deliberately the quietest thing on the page: somebody booking a room has
             no use for it, and the person on the telephone asking "what does it say at
             the bottom" has. -->
        <footer class="mx-auto flex w-full max-w-4xl flex-col items-center gap-1 px-4 pb-8 text-center text-xs text-dimmed">
            <span>{{ address }}</span>
            <AppVersion />
        </footer>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'

    import AppVersion from '@/components/app/AppVersion.vue'
    import Topbar from '@/layouts/components/Topbar.vue'
    import { useBookingStore } from '@/stores/booking'

    const store = useBookingStore()

    // The house's postal address, on every page. It is the one fact that tells a
    // visitor they are looking at the right hotel — there are four Hotel Central in
    // this country and a booking site that never says which one is a booking site
    // somebody will get wrong.
    const address = computed((): string => {
        const property = store.property
        if (!property) return ''

        return [property.name, property.address?.street, [property.address?.postal_code, property.address?.city]
            .filter(Boolean).join(' ')].filter(Boolean).join(' · ')
    })
</script>
